import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

type Size = "small" | "medium" | "normal" | "large" | "larger";

type SpinnerProps = {
  size?: Size;
  delay?: number;
  color?: string;
};

const getFontSize = (size?: Size) => {
  switch (size) {
    case "larger":
      return 48;
    case "large":
      return 36;
    case "normal":
      return 24;
    case "medium":
      return 20;
    case "small":
      return 16;
    default:
      return 24;
  }
};

export const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: getFontSize(props.size),
        color: props.color,
      }}
      spin
    />
  );
  return <Spin delay={props.delay} indicator={antIcon} />;
};
